import { render, staticRenderFns } from "./MonthlyIncomeGoalCard.vue?vue&type=template&id=af56e2e8&scoped=true&"
import script from "./MonthlyIncomeGoalCard.vue?vue&type=script&lang=js&"
export * from "./MonthlyIncomeGoalCard.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyIncomeGoalCard.vue?vue&type=style&index=0&id=af56e2e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af56e2e8",
  null
  
)

export default component.exports